import React, { forwardRef } from "react";
import { TextField } from "@mui/material";

const formatNumber = (value) => {
  if (value === 0) return "0";
  if (!value) return "";
  if (typeof value !== "string") value = String(value);
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

const CurrencyInput = forwardRef(({ value, onChange, name, ...rest }, ref) => {
  const handleChange = (e) => {
    let rawValue = e.target.value.replace(/\D/g, "");
    if (rawValue.length > 1) {
      rawValue = rawValue.replace(/^0+/, "") || "";
    }
    let formattedValue = formatNumber(rawValue);

    onChange({
      target: {
        name: name,
        value: formattedValue,
      },
    });
  };

  const formattedValue = formatNumber(value || "");

  return (
    <TextField
      ref={ref}
      name={name}
      variant="standard" 
      value={formattedValue}
      onChange={handleChange}
      fullWidth
      {...rest}
    />
  );
});

export default CurrencyInput;
